import { createClient } from '@connectrpc/connect';
import { SimulationsService } from '@wavingroup/aqora-v2-crate/wavin/simulations/v1/simulations_service_pb';
import { transport } from '~/services/api/service-transport';

export const simulationsClient = createClient(SimulationsService, transport);
